export default __webpack_public_path__ + "static/media/silver.a8616251.svg";